var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Translate } from "../../I18N";
import Numeric from "./Numeric";

export default class NumericRange extends Component {
  constructor(props) {
    super(props);
    const value = props.value || {};
    this.state = { from: value.from, to: value.to };
  }

  onChange(prop, value) {
    const newState = _objectSpread(_objectSpread({},
    this.state), {}, {
      [prop]: value });


    this.setState(newState);

    const { from, to } = newState;

    this.props.onChange(_objectSpread(_objectSpread({},
    from !== '' ? { from } : {}),
    to !== '' ? { to } : {})
    );
  }

  render() {
    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("div", { className: "Numeric__From" }, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Label date \"From\"" }, void 0, "From:"), /*#__PURE__*/
      _jsx(Numeric, { value: this.state.from, onChange: (val) => this.onChange('from', val) })
      ), /*#__PURE__*/
      _jsx("div", { className: "Numeric__To" }, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Label date \"to\"" }, void 0, "To:"), /*#__PURE__*/
      _jsx(Numeric, { value: this.state.to, onChange: (val) => this.onChange('to', val) })
      )
      ));

  }
}